import { ALLOWED_ORDER_TASKS, CHIP_COLORS, ORDER_TASKS_UPSELLS } from './constants';

export function getTimelineItems(orderTasks) {
  const validStatuses = Object.keys(CHIP_COLORS);
  return orderTasks.filter((item) => ALLOWED_ORDER_TASKS.includes(item.type)
  && validStatuses.includes(item.status)).map((item) => ({
    ...item,
    color: CHIP_COLORS[item.status]
  })).sort((a, b) => ALLOWED_ORDER_TASKS.indexOf(a.type) - ALLOWED_ORDER_TASKS.indexOf(b.type));
}

export function getUpsellItems(type, entitlements) {
  if (!entitlements) {
    return [];
  }

  const typeUpsells = ORDER_TASKS_UPSELLS[type] || [];
  return typeUpsells.filter((upsell) => !entitlements?.has(upsell.entitlement));
}
